// Identidade do produto centralizada: altere aqui nome, slogan e cores.
// Usado pelo front (títulos, manifest, tema) e pelo back (e-mails).

export const brand = {
  name: 'Lar em Dia',
  shortName: 'Lar em Dia',
  tagline: 'Organize a casa sem precisar lembrar e cobrar todo mundo.',
  supportEmail: 'contato@exemplo.com.br',
  colors: {
    primary: '#2f6f62',
    primaryStrong: '#235a4f',
    accent: '#e0873a',
    background: '#faf7f2',
  },
};
